import { useForm, useFormState } from 'react-final-form'

import Button from 'common/components/button'
import MenuButton, { MenuItem } from 'common/components/menuButton'
import { ChevronDown } from 'common/icons'

type Props = {
  isLoading: boolean
  'data-testid'?: string
  onApplyToAll: () => void
  onApplyToNew: () => void
}

const ManageMergeTagApplyToButton = ({
  isLoading,
  'data-testid': dataTestId,
  onApplyToAll,
  onApplyToNew,
}: Props) => {
  const form = useForm()
  const { hasValidationErrors, pristine, values } = useFormState()

  const hasAtLeastOneExample = values.merge_tag_example_values?.some(
    (value) => value
  )

  const isDisabled =
    hasValidationErrors || pristine || isLoading || !hasAtLeastOneExample

  return (
    <MenuButton
      align="end"
      options={
        <>
          <MenuItem
            data-testid="apply-option-all"
            disabled={isDisabled}
            onClick={() => {
              onApplyToAll()
              form.submit()
            }}
          >
            Update all existing content
          </MenuItem>
          <MenuItem
            data-testid="apply-option-new"
            disabled={isDisabled}
            onClick={() => {
              onApplyToNew()
              form.submit()
            }}
          >
            Update only new content
          </MenuItem>
        </>
      }
      menuButton={
        <Button
          data-testid={dataTestId}
          variant="primary"
          className="mr-6"
          loading={isLoading}
          disabled={isDisabled}
          suffixIcon={<ChevronDown className="text-maroon-200" size={4} />}
        >
          Apply to
        </Button>
      }
    />
  )
}

export default ManageMergeTagApplyToButton
